// global
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
  loading: false,
  message: {
    title: '',
    show: false,
    success: true
  }
};

const TEMPLATE_NAME = 'FEEDBACK';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return {
        ...state,
        ...initialState
      };
    }
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false,
        message: action.payload
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      return {
        ...state,
        loading: false,
        message: action.payload
      };
    }
    case `${TEMPLATE_NAME}_CLEAR`: {
      return {
        ...state,
        ...initialState
      };
    }
    default:
      return state;
  }
};

export default reducer;
